export const storeQueryParams = () => {
  // Grab the query string without the leading '?'
  const query = window.location.search.substring(1);
  if (query) {
    // Persist so that it survives navigation within the splash page
    localStorage.setItem("nudgie_saved_query", query);
  }
};

export const getAppUrl = () => {
  const base = "https://nudgieai.com";
  const saved = localStorage.getItem("nudgie_saved_query");
  if (saved && saved.trim().length > 0) {
    // Avoid duplicating '?'
    return `${base}?${saved}`;
  }
  return base;
};
